import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PinValidatorService } from '../../services/pin-validator.service';
import { ToastMessages } from '../../../shared/models/component-messages/toast-messages';

@Component({
  selector: 'app-certificate-dialog',
  templateUrl: './certificate-dialog.component.html',
  styleUrls: ['./certificate-dialog.component.scss']
})
export class CertificateDialogComponent implements OnInit {

  public toastMessages = new ToastMessages();
  public isChar = true;
  public isBreak = false;
  public numberChance = 3;
  @ViewChild('pin', {static: false}) pinElementRef: ElementRef;


  constructor(private translate: TranslateService, private pinValidator: PinValidatorService) {
  }

  public ngOnInit() {
    setTimeout(() => {
      this.pinElementRef.nativeElement.focus();
    }, 100);
    this.pinValidator.setPin();
    this.translate.stream(this.toastMessages.correctPinCode).subscribe(value => this.pinValidator.CORRECT = value);
    this.translate.stream(this.toastMessages.incorrectPinCode).subscribe(value => this.pinValidator.INCORRECT = value);
    this.translate.stream(this.toastMessages.successTitle).subscribe(value => this.pinValidator.SUCCESS = value);
    this.translate.stream(this.toastMessages.error).subscribe(value => this.pinValidator.ERROR = value);
    this.translate.stream(this.toastMessages.removePin).subscribe(value => this.pinValidator.REMOVE = value);
  }

  public checkIfCharacterIsNumber(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      this.isChar = false;
      return false;
    }
    this.isChar = true;
    return true;
  }
}
